// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ip5-","toggle":"styles_toggle__2TqfI","preview":"styles_preview__1yNcH"};